import { render, staticRenderFns } from "./QualityControlAddForm.vue?vue&type=template&id=22015e1f"
import script from "./QualityControlAddForm.vue?vue&type=script&lang=js"
export * from "./QualityControlAddForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports